/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const DIRECT_UPLOAD_CAMPAIGN_MUTATION = gql`
  mutation tenantDirectUpload( $file: [TenantDirectUploadCreateInput!] ) {
    tenant {
      directUploadCampaign( create: $file ) {
        metadata {
          url
          headers
          blobId
          signedBlobId
        }
        errors
      }
    }
  }
`;

export const DIRECT_UPLOAD_COMPANY_MUTATION = gql`
  mutation tenantDirectUpload( $file: [TenantDirectUploadCreateInput!] ) {
    tenant {
      directUploadCompany( create: $file ) {
        metadata {
          url
          headers
          blobId
          signedBlobId
        }
        errors
      }
    }
  }
`;
